import React from 'react';
import FormResetPassword from '../components/authentication/ResetPassword';

function ResetPassword() {
  return (
    <>
      <div className="reset">
        <FormResetPassword />
        </div>
    </>
  );
}

export default ResetPassword;